<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h5 class="heading-1 mb-4">
                    <span>COMPROMETIMENTOS COM ERRO</span>
                </h5>
                <b-tabs v-model="tabIndex">
                    <b-tab title="ENTREGAS" active class="pb-0">
                        <painel-erros-entregas
                            :entregas="dadosPainel.entregasRateios"
                            :movimentosServicos="obterMovimentosServicos()"
                        >
                            <template slot="entregaAcoes" slot-scope="data">
                                <span
                                    class="text-primary"
                                    v-if="$temAcessoView('GEST-ENTR-00')"
                                >
                                    <i
                                        class="fa fa-info-circle fa-lg icon-button"
                                        title="Detalhar"
                                        @click.stop="
                                            detalharEntrega(data.entregaId)
                                        "
                                    ></i>
                                </span> </template
                        ></painel-erros-entregas>
                    </b-tab>
                    <b-tab title="DESPESAS DE VIAGENS" class="pb-0">
                        <painel-erros-desp-viagens
                            :despViagens="dadosPainel.despViagensRateios"
                            :movimentosServicos="obterMovimentosServicos()"
                        ></painel-erros-desp-viagens>
                    </b-tab>
                </b-tabs>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PaineisServicos from './PaineisServicos'
import MovimentosServicos from '../movimentos/MovimentosServicos'
import PainelErrosEntregas from '../../componentes/paineis/PainelErrosEntregas'
import PainelErrosDespViagens from '../../componentes/paineis/PainelErrosDespViagens'

export default {
    data() {
        return {
            tabIndex: 0,
            dadosPainel: {}
        }
    },

    methods: {
        obterPainelErrosComprometimentos() {
            this.$store.dispatch('addRequest')
            PaineisServicos.obterPainelErrosComprometimentos().then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.dadosPainel = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterMovimentosServicos() {
            return MovimentosServicos
        },

        detalharEntrega(entregaId) {
            this.$router.push({
                name: 'Gestores_Entregas_Detalhar',
                params: {
                    entregaId: entregaId
                }
            })
        }
    },

    computed: {},

    created() {
        this.obterPainelErrosComprometimentos()
    },

    watch: {},

    components: {
        PainelErrosEntregas,
        PainelErrosDespViagens
    }
}
</script>
